module.exports = __webpack_public_path__ + "media/7.f0c1bcb1.mp3";